import services from 'services/module';
import { HttpSvcFactory } from 'services/HttpSvc';

export class HostingSvc {
    constructor(private HttpSvc: HttpSvcFactory) {}

    getHostingStats() {
        return this.HttpSvc<anm.UserTraffic>(
            'profile/stats/hosting'
        ).secureGet();
    }
}

services.service('hostingSvc', HostingSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/HostingSvc.ts